import React, { Component } from 'react';


class ModalNoAutorizado extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div className="modal fade" id="modal-no-autorizado" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header" style={{height: '60px'}}>
                            <h2 className="modal-title">No autorizado</h2>
                            {/*<button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>*/}
                        </div>
                        <div className="modal-body">
                            Se produjo un error en la operación por falta de permisos. Contáctese con el personal de soporte.
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
            
            );
    }
}

export default ModalNoAutorizado;


// WEBPACK FOOTER //
// ./Portico/App/Screens/MenuProductos/components/ModalNoAutorizado.jsx